export enum ErrorType {
  PaymentUnsuccessful,
  GlobalWarning,
  Unknown,
}

export enum GlobalErrors {
  loginMessage = 'loginMessage',
}

export type ErrorProps = {
  type?: string;
  data: { ref: string; msg: string } | undefined;
};
